export default {
  // 新增绩效
  insertYgPerformance: '/ygsjzs/ygPerformance/insertYgPerformance',
  // 根据搜索条件批量填写绩效
  insertYgPerformanceByCondition: '/ygsjzs/ygPerformance/insertYgPerformanceByCondition',
  // 修改绩效
  updateYgPerformance: '/ygsjzs/ygPerformance/updateYgPerformance',
  // 查询绩效详情
  selectYgPerformanceById: '/ygsjzs/ygPerformance/selectYgPerformanceById',
  // 分页查询绩效列表
  selectYgPerformanceByPage: '/ygsjzs/ygPerformance/selectYgPerformanceByPage',
  // 查询绩效统计
  selectYgPerformanceJx: '/ygsjzs/ygPerformance/selectYgPerformanceJx',
  // 导出绩效明细 Excel
  exportYgPerformance: '/ygsjzs/ygPerformance/exportYgPerformance',
  // 导出出库绩效PDF
  txOutPerformancePdf: '/ygsjzs/ygPerformance/txOutPerformancePdf',
  // 导出入库绩效PDF
  txInPerformancePdf: '/ygsjzs/ygPerformance/txInPerformancePdf',
  // 导出货转调拨绩效PDF
  txTransferPerformancePdf: '/ygsjzs/ygPerformance/txTransferPerformancePdf',
  // 删除绩效
  deleteYgPerformance: '/ygsjzs/ygPerformance/deleteYgPerformance',
  // 产品维度产量、系数和绩效汇总
  selectSpecSummary: '/ygsjzs/ygPerformancePerson/selectSpecSummary',
  // 组织架构人员
  selectOrganizationUsers: '/ygsjzs/ygPerformancePerson/selectOrganizationUsers',
  // 保存个人绩效分配
  saveAllocation: '/ygsjzs/ygPerformancePerson/saveAllocation'
}
